
import { Link } from "react-router-dom";
import { Package, Users, Check } from "lucide-react";
import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";

interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
  stock?: number;
}

const ProductCard = ({ id, name, price, image, category, stock = 1 }: ProductCardProps) => {
  const [viewers, setViewers] = useState(0);
  const [originalPrice, setOriginalPrice] = useState(0);

  useEffect(() => {
    // Generate random viewers between 1 and 8
    const randomViewers = Math.floor(Math.random() * 8) + 1;
    // Generate random original price between 20-40% higher than current price
    const randomPercentage = Math.random() * (0.4 - 0.2) + 0.2; // between 0.2 and 0.4
    const calculatedOriginalPrice = price * (1 + randomPercentage);
    
    setViewers(randomViewers);
    setOriginalPrice(calculatedOriginalPrice);
  }, [price]);

  return (
    <Link to={`/product/${id}`} className="group">
      <div className="overflow-hidden rounded-2xl bg-white transition-all duration-300 hover:shadow-[0_0_20px_rgba(214,188,250,0.4)] transform hover:-translate-y-1">
        <div className="aspect-square overflow-hidden relative">
          <img
            src={image}
            alt={name}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-2 right-2">
            <Badge className="bg-[#F2FCE2] hover:bg-[#F2FCE2] text-[#2E7D32] text-xs font-medium px-2 py-0.5 flex items-center gap-1">
              <Check className="w-3 h-3" />
              Op voorraad
            </Badge>
          </div>
        </div>
        <div className="p-4">
          <h3 className="text-sm font-medium text-jewelry-text transition-colors group-hover:text-jewelry-gold">
            {name}
          </h3>
          <div className="mt-2 flex items-center gap-2">
            <p className="text-sm font-medium text-red-700">€{price.toFixed(2)}</p>
            <p className="text-xs font-medium text-gray-600 line-through">€{originalPrice.toFixed(2)}</p>
            <span className="text-xs font-medium bg-red-200 text-red-800 px-2 py-0.5 rounded-full">
              {Math.round(((originalPrice - price) / originalPrice) * 100)}% korting
            </span>
          </div>
          <div className="mt-3 space-y-1">
            <div className="flex items-center text-gray-800 text-xs">
              <Package className="w-3 h-3 mr-1 text-red-700" />
              <span className="font-medium text-red-700">
                {stock === 1 ? "Nog maar 1 op voorraad!" : `Nog maar ${stock} op voorraad!`}
              </span>
            </div>
            <div className="flex items-center text-gray-800 text-xs">
              <Users className="w-3 h-3 mr-1 text-gray-700" />
              <span className="text-gray-700">{viewers} mensen bekijken dit</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
